import React, { useState, useEffect, useContext } from "react"
import { NoResultsContainer, Emoji, TextContainer, NoResultsHeader, NoResultsText, ImageContainer, MostPopularTextContainer, MobileTextContainer, MostPopularText, DividerLine } from "./course-filter-no-results.styles"
import { CourseCardsSection } from "../../page-styles/academy.styles"
import { getCourseData } from "../../helpers/coursecard.helper"
import MobileContext from "../../providers/mobile/mobile.provider"

const NoCourseResults = ({ mostPopularCourses, noCoursesEmoji, courseFilter, isSearchSubmitted }) => {
    const { isMobile } = useContext(MobileContext)
    const [sortedCourses, setSortedCourses] = useState([]);

    useEffect(() => {
        const sortCourses = () => {
            if (!mostPopularCourses.length) {
                return [];
            }
            if (courseFilter.sortByValue === "most_recent") {
                return [...mostPopularCourses].sort((a, b) => new Date(b.lastUpdatedOn) - new Date(a.lastUpdatedOn));
            } else if (courseFilter.sortByValue === "most_popular") {
                return [...mostPopularCourses].sort((a, b) => b.coursePopularity - a.coursePopularity);

            }
            return mostPopularCourses;
        };

        setSortedCourses(sortCourses());
    }, [mostPopularCourses, courseFilter]);

    return (
        <>
            <NoResultsContainer>
                {isMobile ? (<div><MobileTextContainer><ImageContainer style={{ marginRight: "5px" }}><Emoji image={noCoursesEmoji.gatsbyImageData} /></ImageContainer>
                    <NoResultsHeader>Oh no!</NoResultsHeader></MobileTextContainer>
                    {isSearchSubmitted ? (<NoResultsText>Sorry we couldn't find any courses that match those search results.</NoResultsText>) : (<NoResultsText>Sorry we couldn't find any courses that match those filters.</NoResultsText>)}
                </div>) : (<><ImageContainer><Emoji image={noCoursesEmoji.gatsbyImageData} /></ImageContainer>
                    <TextContainer>
                        <NoResultsHeader>Oh no!</NoResultsHeader>
                        {isSearchSubmitted ? (<NoResultsText>Sorry we couldn't find any courses that match those search results.</NoResultsText>) : (<NoResultsText>Sorry we couldn't find any courses that match those filters.</NoResultsText>)}
                    </TextContainer></>)}

            </NoResultsContainer>
            <MostPopularTextContainer>
                <MostPopularText>OUR MOST POPULAR COURSES</MostPopularText><DividerLine />
            </MostPopularTextContainer>
            {sortedCourses.length > 0 && (
                <CourseCardsSection isCoursePage={true}>
                    {getCourseData(
                        sortedCourses,
                        {
                            cardImage: "courseImageClick",
                            cardTitle: "courseTitleClick",
                            authorName: "courseAuthorClick",
                            buttonOne: "courseWatchPreviewBtnClick",
                            buttonTwo: "courseDetailsBtnClick",
                        },
                        "small-course-card"
                    )}
                </CourseCardsSection>
            )}
        </>
    )
}

export default NoCourseResults